<template>
	<div class="flex_1 margin_horizontal">
		<AccessRestrictedTabs class="table_tabs"
							  v-model="activeTab"
							  :elements="tabTypes"
							  :session-key="$route.path"
		/>
		<DebtorOverviewTable v-if="activeTab === tabTypes.debtorOverview"/>
	</div>
</template>
<script>

import DebtorOverviewTable from "src/components/templates/seller/debtorManagement/DebtorOverviewTable";
import AccessRestrictedTabs from "@/components/templates/common/permissions/AccessRestrictedTabs";
import {enumDef} from "@/common/enumDefs";
import {navigationTabs} from "@/common/navigation/navigationTabs";

export default {
	components: { AccessRestrictedTabs, DebtorOverviewTable },
	data() {
		let tabTypes = {
			debtorOverview: {
				name: navigationTabs.seller.debtors.overview,
				translationKey: "debtorManagement.overview",
				permission: enumDef.permissions.SellerDebtorManagement
			}
		};

		return {
			tabTypes: tabTypes,
			activeTab: null,
		};
	},
};
</script>